import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'VAT_GROUPS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');

// For now we are overloading the use of UPDATE to include delete too.
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');

export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    UPDATE,
    UPDATE_PROGRESS,
    UPDATE_OK,
    UPDATE_FAIL,

};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('updateSubStateFromAction: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_OK:
                return Object.assign({}, state, {data: action.response, loading: false, error: null});
            case LOAD_FAIL:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});

            case UPDATE:
                return  Object.assign({}, state, {loading: true, error: null, progress: action.progress});
            case UPDATE_PROGRESS:
                return  Object.assign({}, state, {error: null, progress: action.progress});
            case UPDATE_OK:
                return Object.assign({}, state, {dataToken: action.response,loading: false, error: null});
            case UPDATE_FAIL:
                return Object.assign({}, state, {loading: false, failures: action.failures});

            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState );
    return newState;
};

export const API = {
    doGetVATGroups: () => {
        return (dispatch, getState) => {
            dispatch({type: LOAD});
            CLIENT.getVATGroups()
                .then((response) => {
                    dispatch({type: LOAD_OK, response: response});
                })
                .catch((error) => {
                    dispatch({type: LOAD_FAIL, error});
                });
        }
    },
    doAddParents: (companyId,vatGroup) => {
        log.debug('doAddParents', vatGroup,companyId );

        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            CLIENT.AddVATGroupParents(companyId,vatGroup)
                .then((response) => {
                    CLIENT.getVATGroups(companyId)
                        .then((response) => {
                            dispatch({type: LOAD_OK, response: response});
                        })
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },
    doAddChildren: (companyId,vatGroup) => {
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            CLIENT.AddVATGroupChildren(companyId,vatGroup)
                .then((response) => {
                    CLIENT.getVATGroups(companyId)
                        .then((response) => {
                            dispatch({type: LOAD_OK, response: response});
                        })
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },
    doDeleteParents: (companyId) => {
        log.debug('doDeleteParents',companyId );

        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            CLIENT.deleteVATGroupParents(companyId)
                .then((response) => {
                    CLIENT.getVATGroups(companyId)
                        .then((response) => {
                            dispatch({type: LOAD_OK, response: response});
                        })
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },
    doDeleteChildren: (companyId) => {
        log.debug('doDeleteChildren',companyId );

        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            CLIENT.deleteVATGroupChildren(companyId)
                .then((response) => {
                    CLIENT.getVATGroups(companyId)
                        .then((response) => {
                            dispatch({type: LOAD_OK, response: response});
                        })
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },

};

export default API;

